// @ngInject
function AccountsApiService(
  $q,
  $rootScope,
  DS,
  DSHttpAdapter,
  ResourcesService
) {
  let endpoint = "accounts";

  return {
    getAccounts: getAccounts,
    getAccount: ResourcesService.apiRms2Factory.get(endpoint),
    getLanguages: ResourcesService.apiRms2Factory.get(endpoint + "/languages"),
    createAccount: ResourcesService.apiRms2Factory.create(endpoint, "Account"),
    updateAccount: ResourcesService.apiRms2Factory.update(endpoint, "Account"),
    deleteAccount: ResourcesService.apiRms2Factory.delete(endpoint, "Account"),
  };

  function getAccounts() {
    let deferred = $q.defer();

    DSHttpAdapter.GET(DS.defaults.rms2Path + endpoint).then(
      function (response) {
        deferred.resolve(response.data.accounts);
      },
      function (error) {
        deferred.reject(handleError(error));
      }
    );
    return deferred.promise;
  }

  function handleError(error) {
    return ResourcesService.handleResourceError(error);
  }
}

angular
  .module("accounts.api", [])
  .factory("AccountsApiService", AccountsApiService);
